import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ServerConstants} from '../../../model/ServerConstants';
import {NameServerVO, TopLevelDomainVO} from '../../../generate/TopLevelDomainVO';
import {ChangeVO} from '../../../generate/ChangeVO';


@Component({
  selector: 'name-servers',
  templateUrl: './name-servers.component.html',
  styleUrls: ['./name-servers.component.scss']
})
export class NameServersComponent implements OnInit {

  @Input()
  domain: TopLevelDomainVO;

  @Input()
  nsChange: ChangeVO;

  editmode: boolean;

  @Input()
  pendingRequestChangeID: string;

  @Output()
  modifiedTLDOutput = new EventEmitter<TopLevelDomainVO>();
  @Input()
  viewMode: boolean;
  serverConstants = ServerConstants;

  constructor() {
  }

  ngOnInit() {
  }

  edit(val) {
    this.editmode = val;
  }

  cancel(val) {
    this.edit(false);
  }

  nameServerOutPut(nameServers: Array<NameServerVO>) {
    this.domain.nameServers = nameServers;
    this.modifiedTLDOutput.emit(this.domain);
    this.edit(false);
  }

}
